import { apiJson } from './api';

export type PublicConfig = {
  google_client_id: string;
  ga_measurement_id: string;
  mixpanel_token: string;
};

// Memoised — called on boot for analytics and again on Home for Google client id.
let cached: Promise<PublicConfig> | null = null;

export function fetchPublicConfig(): Promise<PublicConfig> {
  if (!cached) cached = apiJson<PublicConfig>('/api/config/');
  return cached;
}

// Test-only: clears the memoised value so each test sees its own mock.
export function _resetConfigCache(): void {
  cached = null;
}
